module.exports = __webpack_public_path__ + "ava.304de3e791979299f072.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ava.woff2
// module id = ./src/assets/webfonts/ava.woff2
// module chunks = styles